import { LineOfBusinessResponseModel } from "./line-of-business-response.model";

export class UserTypeResponseModel {
    constructor(
      public id: string,
      public code: string,
      public lineOfBusiness: LineOfBusinessResponseModel
    ) {}
  }